import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '@/views/Home.vue';
import Authentication from '@/views/Authentication.vue';
import { Auth } from 'aws-amplify';
import MenuEngineeringAddDish from '@/views/menu-engineering/AddDish.vue';
import MenuEngineeringEditDish from '@/views/menu-engineering/EditDish.vue';
import MenuEngineeringResults from '@/views/menu-engineering/Results.vue';
import MenuEngineeringCategory from '@/views/menu-engineering/Category.vue';
import MenuEngineeringWelcome from '@/views/menu-engineering/try-out/Welcome.vue';
import GoogleTagManagerLogic from '@/logic/google-tag-manager/GoogleTagManagerLogic';
import MenuEngineeringWelcomeResult from '@/views/menu-engineering/try-out/WelcomeResult.vue';
import ContentPage from '@/views/content/ContentPage.vue';
import MyProfile from '@/views/profile/MyProfile.vue';
import AuthGroup from '@/logic/auth/AuthGroup';
import store from '@/store';
import TrackingService from '@/logic/profile/TrackingService';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/auth',
    name: 'authentication',
    component: Authentication,
    meta: { requiresAuth: AuthGroup.None },
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { requiresAuth: AuthGroup.Indirect },
  },
  {
    path: '/my-orders',
    name: 'my-orders',
    component: Home,
    meta: { requiresAuth: AuthGroup.Direct },
  },
  {
    path: '/menu-engineering/add-dish',
    component: MenuEngineeringAddDish,
    meta: { requiresAuth: AuthGroup.Indirect },
  },
  {
    path: '/menu-engineering/edit-dish/:dishId',
    component: MenuEngineeringEditDish,
    meta: { requiresAuth: AuthGroup.Indirect },
  },
  {
    path: '/menu-engineering/results',
    component: MenuEngineeringResults,
    meta: { requiresAuth: AuthGroup.Indirect },
  },
  {
    path: '/menu-engineering/category/:category',
    component: MenuEngineeringCategory,
    meta: { requiresAuth: AuthGroup.Indirect },
  },
  {
    path: '/menu-engineering/calculate-your-dishes',
    component: MenuEngineeringWelcome,
    meta: { requiresAuth: AuthGroup.None },
  },
  {
    path: '/menu-engineering/result/:category',
    component: MenuEngineeringWelcomeResult,
    meta: { requiresAuth: AuthGroup.None },
  },
  {
    path: '/settings/profile',
    component: MyProfile,
    meta: { requiresAuth: AuthGroup.Indirect },
  },
  {
    path: '/privacy',
    component: ContentPage,
    meta: { requiresAuth: AuthGroup.None },
  },
  {
    path: '/terms-and-conditions',
    component: ContentPage,
    meta: { requiresAuth: AuthGroup.None },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeResolve(async (to, from, next) => {
  TrackingService.storeUtmParameters(to);
  if (
    to.matched.some((record) => record.meta.requiresAuth !== AuthGroup.None)
  ) {
    try {
      await Auth.currentAuthenticatedUser();
      // @ts-ignore
      const profile = { ...store.state.profile.profile };
      if (Object.keys(profile).length === 0) {
        await store.dispatch('profile/getProfile');
      }
      next();
    } catch (e) {
      next({
        path: '/auth',
        query: {
          redirect: to.fullPath,
        },
      });
    }
  }
  next();
});

router.afterEach(async (to) => {
  GoogleTagManagerLogic.pushEvent('viewpage', to.fullPath);
});

export default router;
